import type { ResourceName, ResourceScope } from "../entities/Types";
import type { IFeature, IContent } from "@eusoft/webapp-ui";

export interface IResourcePermission {
    res: ResourceName;
    scope: ResourceScope | ResourceScope[];
    resId?: string;
}

export interface IAuthorizeFeature extends IFeature<IContent<ObjectLike>> {
    data: IResourcePermission[];
    type: "Authorize";
}

export function isAuthorize(feature: IFeature<IContent<ObjectLike>>) {
    return "type" in feature && feature.type == "Authorize";
}